export default "__VITE_ASSET__2HmmHtdk__"